import { Component, OnDestroy } from '@angular/core';
import { finalize, takeUntil } from 'rxjs/operators';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { AppConfigQuery } from '../../../core/state/app-config/app-config.query';

@Component({
    selector: 'app-file-upload-component',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnDestroy {
    unsubscribe$ = new Subject();

    constructor(private appConfig: AppConfigQuery, private http: HttpClient) {}
    fileName = '';
    // TODO: show progress?
    uploadProgress: number;
    upload$: Observable<any>;

    onFileSelected(event) {
        const file: File = event.target.files[0];
        if (file) {
            this.fileName = file.name;
            const formData = new FormData();
            formData.append('file', file);

            this.upload$ = this.http
                .post(`${this.appConfig.get().gatewayBaseUrl}/csv`, formData, {
                    reportProgress: true,
                    observe: 'events'
                })
                .pipe(
                    takeUntil(this.unsubscribe$),
                    finalize(() => {
                        // TODO: show success toast
                        this.reset();
                    })
                );
        }
    }

    uploadFile() {
        this.upload$.subscribe(
            (event) => {
                if (event.type == HttpEventType.UploadProgress) {
                    this.uploadProgress = Math.round(100 * (event.loaded / event.total));
                }
            },
            (error) => {
                // TODO: show error toast
                console.error(error);
            }
        );
    }

    cancelUpload() {
        // TODO: show cancel toast
        this.unsubscribe$.next(true);
        this.reset();
    }

    reset() {
        this.uploadProgress = null;
    }

    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
